import React from 'react';
import { Tooltip, Box, Typography } from '@mui/material';

const estados = {
  5: { nombre: 'Iniciada', color: '#0073EA' },
  2: { nombre: 'En proceso', color: '#fcab3c' },
  3: { nombre: 'Terminada', color: '#00c875' },
  1: { nombre: 'No iniciada', color: '#df2f4a' },
  4: { nombre: 'No se realizara', color: '#4b4c6a' },
};

const EstadoModal = ({ StatusList }) => {
  const total = StatusList && StatusList.total ? StatusList.total : 0;
  const isEmpty = !StatusList || total === 0;

  // Filtrar los estados activos sólo si StatusList está definido
  const activeStates = StatusList ? Object.keys(estados).filter(key => StatusList[key] > 0) : [];
  const numStates = activeStates.length;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '150px',
        height: '100%',
        padding: '4px',
      }}
    >
      {isEmpty ? (
        <Box
          sx={{
            width: '150px',
            height: 25,
            backgroundColor: '#B0B0B0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            m: 0.1,
            borderRadius: 0.3,
          }}
        />
      ) : (
        <Box sx={{ display: 'flex', width: '100%', height: 25 }}>
          {Object.keys(estados).map((key) => {
            const count = StatusList && StatusList[key] ? StatusList[key] : 0;
            if (count > 0) {
              const porcentaje = ((count / total) * 100).toFixed(2);
              const minWidth = numStates > 0 ? `${100 / numStates}%` : '100%';

              return (
                <Tooltip
                  key={key}
                  title={
                    <Typography variant="subtitle1">
                      {`${estados[key].nombre} ${count}/${total} (${porcentaje}%)`}
                    </Typography>
                  }
                  placement="top"
                  arrow
                >
                  <Box
                    sx={{
                      width: minWidth,
                      height: 25,
                      backgroundColor: estados[key].color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      m: 0.0,
                      borderRadius: 0.4,
                      transition: 'transform 0.3s',
                      '&:hover': {
                        transform: 'scale(1.1)',
                      },
                    }}
                  />
                </Tooltip>
              );
            }
            return null;
          })}
        </Box>
      )}
    </Box>
  );
};

export default EstadoModal;

